import * as React from "react";
import Plyr from "plyr-react";
import "plyr-react/dist/plyr.css";

const Player = ({ files, title, poster }) => {
  return (
    <Plyr
      source={{
        type: "video",
        title: title,
        poster,
        sources: [
          {
            src: files.p720,
            type: "video/mp4",
            size: 720,
          },
          {
            src: files.p1080,
            type: "video/mp4",
            size: 1080,
          },
          {
            src: files.p360,
            type: "video/mp4",
            size: 360,
          },
          {
            src: files.p2160,
            type: "video/mp4",
            size: 2160,
          },
        ],
      }}
      options={{
        autoplay: false,
        muted: false,
        quality: {
          default: 720,
          options: [
            files.p2160 && 2160,
            files.p1080 && 1080,
            files.p720 && 720,
            files.p360 && 360,
          ],
        },
        i18n: {
          restart: "Сначала",
          rewind: "Перемотать {seektime} с",
          play: "Смотреть",
          pause: "Пауза",
          fastForward: "Вперед {seektime} с",
          seek: "Искать",
          seekLabel: "{currentTime} из {duration}",
          played: "Просмотрено",
          buffered: "Буферизировано",
          currentTime: "Текущее время",
          duration: "Длительность",
          volume: "Громкость",
          mute: "Без звука",
          unmute: "Со звуком",
          enableCaptions: "Включить субтитры",
          disableCaptions: "Выключить субтитры",
          download: "Скачать",
          enterFullscreen: "Полноэкранный режим",
          exitFullscreen: "Закрыть полноэкранный режим",
          frameTitle: "Плеер для {title}",
          captions: "Субтитры",
          settings: "Настройки",
          pip: "Плавающее окно",
          menuBack: "Вернуться",
          speed: "Скорость",
          normal: "Нормальная",
          quality: "Качество",
          loop: "На повторе",
          start: "Start",
          end: "End",
          all: "All",
          reset: "Reset",
          disabled: "Выключено",
          enabled: "Включено",
          advertisement: "Реклама",
          qualityBadge: {
            2160: "4K",
            1440: "HD",
            1080: "HD",
            720: "HD",
            576: "SD",
            480: "SD",
          },
        },
      }}
    />
  );
};

export default Player;
